import { createSlice } from "@reduxjs/toolkit";

const timeSheetRoleSlice = createSlice({
    name: "timeSheetRoleSlice",
    initialState: {
        isLoading: false,
        rolePaginationList: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
    },
});

export const { setIsLoading, setRolePaginationList } = timeSheetRoleSlice.actions;
export default timeSheetRoleSlice.reducer;